/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type BuyBciMutationVariables = Types.Exact<{
	input: Types.BciTradeRequest;
}>;

export type BuyBciMutation = {
	__typename?: "Mutation";
	buyBci:
		| {
				__typename?: "BciTradeInProgressResponse";
				tradeInProgress: { __typename?: "BciTradeInProgress"; tradeId: string };
		  }
		| {
				__typename?: "BciTradeSuccessResponse";
				trade: { __typename?: "BciTrade"; tradeId: string; wallet: { __typename?: "Wallet"; id: string } };
		  };
};

export const BuyBciDocument = gql`
	mutation buyBci($input: BciTradeRequest!) {
		buyBci(request: $input) {
			... on BciTradeSuccessResponse {
				trade {
					tradeId
					wallet {
						id
					}
				}
			}
			... on BciTradeInProgressResponse {
				tradeInProgress {
					tradeId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class BuyBciGQLService extends Apollo.Mutation<BuyBciMutation, BuyBciMutationVariables> {
	document = BuyBciDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
